@if (result != null && visibleCustomerSummaryMetrics.length > 0) {
	<section class="rea-section">
		<div class="rea-section__header">
			<h4>Resumen</h4>
		</div>

		<div class="rea-metrics">
			@for (metric of visibleCustomerSummaryMetrics; track metric.label) {
				<div class="rea-metric">
					<span class="rea-metric__value">{{ metric.value }}</span>
					<span class="rea-metric__label">{{ metric.label }}</span>
				</div>
			}
		</div>
	</section>
}
